import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import Title from '../title/Title';
import InputOptionDownloadComponent from '../input-option-download/InputOptionDownloadComponent';

const TitleWithRightAction = (props) => {
    const { title, tooltipText, action, onClick, children } = props;

    const renderViewAllButton = () => (
        <Button
            className="!font-semibold !text-[14px] !leading-[17px] text-green"
            size="small"
            onClick={onClick}
        >
            View all
        </Button>
    );

    const renderDownloadButton = () => <InputOptionDownloadComponent onSelect={onClick} />;

    return (
        <div className='flex justify-between items-center'>
            <Title title={title} tooltipText={tooltipText} />
            {action === 'view-all' && renderViewAllButton()}
            {action === 'download' && renderDownloadButton()}
            {children}
        </div>
    )
}

TitleWithRightAction.propTypes = {
    title: PropTypes.string.isRequired,
    tooltipText: PropTypes.string,
    action: PropTypes.oneOf(['view-all', 'download']),
    onClick: PropTypes.func,
};

export default TitleWithRightAction;